(() => {
  const formatMoney = (cents) => {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    const tpl = (window.PP && PP.money) || '{{amount_with_comma_separator}} zł';
    return tpl.replace(/\{\{\s*\w+\s*\}\}/, value);
  };
  const unitsOf = (value) => parseInt(String(value).trim().split(' ')[0], 10) || 1;
  const imgUrl = (src, width) => {
    if (!src) return '';
    const url = src.startsWith('//') ? 'https:' + src : src;
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  };

  /* ---------- Buybox ---------- */
  document.querySelectorAll('[data-buybox]').forEach((box) => {
    const json = box.querySelector('[data-product-json]');
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const ci = Number(box.dataset.colorIndex);
    const bi = Number(box.dataset.bundleIndex);
    const form = box.querySelector('[data-product-form]');
    const idInput = form.querySelector('[data-variant-id]');
    const addBtn = form.querySelector('[data-add-btn]');
    const addLabel = form.querySelector('[data-add-label]');
    const colorLabel = box.querySelector('[data-color-label]');
    const errorEl = form.querySelector('[data-form-error]');
    const mainImg = box.querySelector('[data-gallery-main]');
    const thumbs = box.querySelectorAll('[data-thumb]');

    const selected = (sel) => { const el = form.querySelector(sel + ':checked'); return el ? el.value : null; };
    const findVariant = (color, bundle) => product.variants.find((v) =>
      (color === null || v.options[ci] === color) && (bundle === null || v.options[bi] === bundle));

    const showImage = (src, mediaId) => {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = imgUrl(src, 1400);
      thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.mediaId === String(mediaId))));
    };

    const update = (changedColor) => {
      const color = product.options.length > 1 ? selected('[data-color-input]') : null;
      const bundle = selected('[data-bundle-input]');
      const variant = findVariant(color, bundle) || product.variants[0];
      idInput.value = variant.id;
      if (colorLabel && color) colorLabel.textContent = color;

      const single = findVariant(color, product.variants.map((v) => v.options[bi]).find((o) => unitsOf(o) === 1) || null);
      form.querySelectorAll('[data-bundle-input]').forEach((input) => {
        const v = findVariant(color, input.value);
        if (!v) return;
        const label = input.nextElementSibling;
        const units = unitsOf(input.value);
        const priceEl = label.querySelector('[data-bundle-price]');
        const perEl = label.querySelector('[data-per-unit]');
        const saveEl = label.querySelector('[data-saved]');
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (perEl && units > 1) perEl.textContent = formatMoney(Math.round(v.price / units)) + ' za matę';
        if (saveEl && single) saveEl.textContent = 'Oszczędzasz ' + formatMoney(single.price * units - v.price);
      });

      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Dodaj do koszyka · ' + formatMoney(variant.price) : 'Chwilowo niedostępne';
      if (changedColor && variant.featured_image) showImage(variant.featured_image.src, variant.featured_image.id);
      document.querySelectorAll('[data-sticky-price]').forEach((el) => { el.textContent = formatMoney(variant.price); });
    };

    form.addEventListener('change', (e) => update(e.target.matches('[data-color-input]')));
    thumbs.forEach((t) => t.addEventListener('click', () => showImage(t.dataset.src.replace(/[?&]width=\d+/, ''), t.dataset.mediaId)));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      addBtn.disabled = true;
      try {
        const res = await fetch(PP.routes.cart_add + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Nie udało się dodać do koszyka.');
        await Cart.refresh();
        Cart.open();
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        addBtn.disabled = false;
      }
    });
  });

  /* ---------- Cart drawer ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const Cart = {
    open() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; drawer.querySelector('.drawer__close').focus(); },
    close() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; },
    async refresh() {
      const cart = await (await fetch(PP.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      Cart.render(cart);
      return cart;
    },
    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      if (!drawer) return;
      const items = drawer.querySelector('[data-cart-items]');
      drawer.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price);
      drawer.querySelector('[data-cart-foot]').hidden = cart.item_count === 0;
      if (!cart.item_count) { items.innerHTML = '<div class="drawer__empty">Koszyk jest pusty.</div>'; return; }
      items.innerHTML = cart.items.map((it) => `
        <div class="line" data-key="${it.key}">
          ${it.image ? `<img src="${imgUrl(it.image, 160)}" alt="">` : '<span></span>'}
          <div>
            <div class="line__title">${it.product_title}</div>
            ${it.variant_title ? `<div class="line__variant">${it.variant_title}</div>` : ''}
            <div class="qty">
              <button type="button" data-qty="${it.quantity - 1}" aria-label="Mniej">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-qty="${it.quantity + 1}" aria-label="Więcej">+</button>
            </div>
          </div>
          <div class="line__price">${formatMoney(it.final_line_price)}</div>
        </div>`).join('');
    },
  };
  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-cart-close]')) return Cart.close();
      const btn = e.target.closest('[data-qty]');
      if (!btn) return;
      const key = btn.closest('[data-key]').dataset.key;
      const res = await fetch(PP.routes.cart_change + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Number(btn.dataset.qty) }),
      });
      Cart.render(await res.json());
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') Cart.close(); });
  }
  document.querySelectorAll('[data-cart-open]').forEach((b) => b.addEventListener('click', async () => { await Cart.refresh(); Cart.open(); }));

  /* ---------- Sticky CTA: visible after the hero, hidden while the buybox is on screen ---------- */
  const sticky = document.querySelector('[data-sticky-cta]');
  const target = document.getElementById('zestaw');
  if (sticky && target && 'IntersectionObserver' in window) {
    let pastTop = false; let buyVisible = false;
    const sync = () => sticky.classList.toggle('is-visible', pastTop && !buyVisible);
    new IntersectionObserver(([en]) => { buyVisible = en.isIntersecting; sync(); }, { threshold: 0.05 }).observe(target);
    window.addEventListener('scroll', () => { pastTop = window.scrollY > 600; sync(); }, { passive: true });
  }
})();
